import { SUBSCRIPTION_STATES } from './stripe/productMeta'

// Which products are locked for the current user: { [product]: boolean }.
//
// Source of truth for product locks. Mirrors `lockedProductMap` in
// components/globals/Sidebar.vue, which should be migrated to use this.
//
//   subscription    AuthModule/getUserSubscription
//   isLegacy        AuthModule/getIsLegacy
//   lensLimit       AuthModule/getLensLimit
//   spyderLimit     AuthModule/getSpyderLimit
//   guestStatus     AuthModule/getGuestStatus
//   hasApiAccess    AuthModule/getHasApiAccess
//   paymentPastDue  whether the subscription is past due
export const getLockedProductMap = ({
  subscription,
  isLegacy,
  lensLimit,
  spyderLimit,
  guestStatus,
  hasApiAccess,
  paymentPastDue
}) => {
  const isBasic = subscription?.internalProductId === 'basic_plan'

  const lensLimitValue = lensLimit || 0
  const spyderLimitValue = spyderLimit || 0
  const { isGuestOnly, isGuest } = guestStatus || {}
  const guestBypass = isGuestOnly ? false : isGuest

  const noSub = subscription?.status === SUBSCRIPTION_STATES.NOT_ACTIVE || !subscription?.status

  const noSubNoLimit = !subscription?.addOns?.lens && lensLimitValue === 0
  if (noSub) {
    return {
      briefs: true,
      discovery: true,
      spyder: true,
      lens: !isGuestOnly,
      library: true,
      api: !hasApiAccess
    }
  }
  return {
    briefs: isGuestOnly || paymentPastDue,
    discovery: isGuestOnly,
    spyder: ((isBasic && spyderLimitValue === 0) || (isLegacy && spyderLimitValue === 0) || spyderLimitValue === 0) || paymentPastDue,
    lens: guestBypass ? false : noSubNoLimit || paymentPastDue,
    library: isGuestOnly || paymentPastDue,
    api: !hasApiAccess
  }
}
